import { Flex, Tag, useDisclosure } from "@chakra-ui/react";
import { useMemo } from "react";

const TRUNCATE_AT = 2;

export function ScenarioTags({ tags }: { tags: string[] }) {
  const { isOpen: showAll, onToggle: toggleShowAll } = useDisclosure();

  const tagValues = useMemo(() => Array.from(new Set(tags)), [tags]);

  const displayedTags = useMemo(
    () => (showAll ? tagValues : tagValues.slice(0, TRUNCATE_AT)),
    [showAll, tagValues],
  );

  if (!tagValues.length) return null;

  return (
    <Flex gap={2} wrap="wrap" mt="auto">
      {displayedTags.map((t) => (
        <Tag key={t} variant="brand">
          {t}
        </Tag>
      ))}
      {tagValues.length !== TRUNCATE_AT && (
        <Tag variant="outline" onClick={toggleShowAll} cursor="pointer">
          {showAll ? "minder" : `+${tagValues.length - TRUNCATE_AT}`}
        </Tag>
      )}
    </Flex>
  );
}
